import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card card-custom card-stretch mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header border-0 py-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card-body pt-3 pb-0 mt-n3" }
const _hoisted_9 = {
  class: "tab-content mt-4",
  id: "myTabTables2"
}
const _hoisted_10 = {
  class: "tab-pane fade show active",
  id: "kt_tab_pane_2_1",
  role: "tabpanel",
  "aria-labelledby": "kt_tab_pane_2_1"
}
const _hoisted_11 = {
  id: "kt_sidebar_content",
  class: "table-responsive"
}
const _hoisted_12 = { class: "table table-borderless align-middle" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" })
  ])
], -1)
const _hoisted_14 = { class: "px-0 py-2" }
const _hoisted_15 = { class: "px-5" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", {
          class: "card-label fw-bolder text-dark fs-1",
          innerHTML: _ctx.titleText
        }, null, 8, _hoisted_4),
        _createElementVNode("span", {
          class: "text-muted mt-2 fw-bold fs-2",
          innerHTML: _ctx.subtitleText
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-color-primary btn-active-light-primary",
          "data-kt-menu-placement": "bottom-end",
          "data-kt-menu-flip": "top-end",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push(_ctx.urlPathText))
        }, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.toolbarButtonLabelText), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectionData, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", {
                        class: "bgi-no-repeat bgi-size-cover min-h-200px min-w-300px",
                        style: _normalizeStyle(`background-image: url('${item.metadata.images[0].href}')`)
                      }, null, 4)
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "text-gray-800 fw-bolder text-hover-primary fs-6",
                        innerHTML: item.name
                      }, null, 8, _hoisted_16),
                      _createElementVNode("span", {
                        class: "text-muted fw-bold d-block mt-1",
                        innerHTML: item.metadata.address
                      }, null, 8, _hoisted_17),
                      _createElementVNode("span", {
                        class: "text-muted fw-bold d-block mt-4",
                        innerHTML: item.metadata.phone
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", {
                        class: "text-muted fw-bold d-block mt-1",
                        innerHTML: item.metadata.website
                      }, null, 8, _hoisted_19)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}